/*
 * @forgerock/javascript-sdk
 *
 * constants.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/** @hidden */
var DEFAULT_TIMEOUT = 60 * 1000;
var DEFAULT_OAUTH_THRESHOLD = 30 * 1000;
export { DEFAULT_TIMEOUT, DEFAULT_OAUTH_THRESHOLD };
//# sourceMappingURL=constants.js.map